import Vue from "vue";
import Router from "vue-router";
import { DetectMobile } from "./../mixins/detectmobile";
import { DetectWC } from "../mixins/wcDetector";
import { routerGuard } from "../api/routerguard";
import Shop from "../components/shop/Shop.vue";
import AboutPage from "./../views/about";
import ContactPage from "./../views/contact";
import PrivacyPage from "./../views/privacy";
import login from "./../components/user/login.vue";
import register from "./../components/user/register.vue";
import registerAccount from "./../components/shop/register/RegisterAccount.vue";
import registerAccountMobile from "./../components/shop/register/RegisterAccountMobile.vue";
import registerMobile from "./../components/user/registerMobile.vue";
import giftshop from "./../components/giftcard/giftshop/GiftShop.vue";
import giftshopMobile from "./../components/giftcard/giftshop/GiftShopMobile.vue";
import Checkout from "./../components/shop/Checkout/Checkout";
import giftcardCheckout from "./../components/giftcard/giftcheckout/GiftCheckout.vue";
import thankYou from "./../components/shop/Checkout/ThankYou";
import thankYouMobile from "./../components/shop/Checkout/ThankYouMobile";
import CheckoutMobile from "./../components/shop/Checkout/CheckoutMobile";
import GiftCheckoutMobile from "./../components/giftcard/giftcheckout/GiftCheckoutMobile.vue";
import Intro from "./../components/master/Intro.vue";
import IntroMobile from "../components/master/IntroMobile.vue";
import shopMobile from "./../components/shop/ShopMobile";
import ShoppingCartMobile from "./../components/shop/shopping-cart/ShoppingCartMobile.vue";
import GiftShoppingCartMobile from "./../components/giftcard/giftshoppingcart/GiftShoppingCartMobile.vue";
import profile from "../components/user/profile.vue";
import profileMobile from "../components/user/profileMobile.vue";
import loginMobile from "./../components/user/loginMobile.vue";
import OrderHistory from "../components/user/OrderHistory.vue";
import OrderHistoryMobile from "../components/user/OrderHistoryMobile.vue";
import Loyalty from "../components/user/Loyalty.vue";
import LoyaltyMobile from "../components/user/LoyaltyMobile.vue";
import userStamps from "../components/user/userStamps.vue";
import userStampsMobile from "../components/user/userStampsMobile.vue";
import OrderTracking from "../components/user/orderTracking.vue";
import OrderTrackingMobile from "../components/user/orderTrackingMobile.vue";
import CompleteOrder from "../components/shop/Checkout/CompleteOrder.vue";
import CompleteOrderMobile from "../components/shop/Checkout/CompleteOrderMobile.vue";
import PageNotFound from "../components/master/PageNotFound";
import GeneralError from "../components/shared/GeneralError";
import LogViewer from "../components/shared/LogViewer.vue";
import QrCodeScanner from "../components/shop/shopping-cart/QrCodeScanner.vue";
import SaveOrderMobile from "../components/shop/Checkout/SaveOrderMobile.vue";
//import { DetectWC } from "../mixins/wcDetector";
Vue.use(Router);

var isMobile = DetectMobile.methods.isMobile();
var isWC = DetectWC.methods.isWC();
const routes = [
  {
    path: "/store/:storename/checkout/giftcards",
    component: isMobile ? GiftCheckoutMobile : giftcardCheckout,
    name: "giftcardCheckout",
    props: true,
    meta: {
      layout: isMobile ? "mobile" : "full"
    }
  },
  {
    path: "/",
    component: isMobile ? IntroMobile : Intro,
    name: "mainpage",
    meta: {
      layout: isMobile ? "mobile" : "full"
    }
  },
  {
    path: "/about",
    component: AboutPage,
    name: "about"
  },
  {
    name: "thankyou",
    path: "/store/:storename/thankyou",
    props: true,
    component: isMobile ? thankYouMobile : thankYou,
    meta: {
      layout: isMobile ? "mobile" : "full"
    }
  },
  {
    name: "thankyougift",
    path: "/store/:storename/giftcards/thankyou",
    props: true,
    component: isMobile ? thankYouMobile : thankYou,
    meta: {
      layout: isMobile ? "mobile" : "full"
    }
  },
  {
    path: "/login/:storename/:forgift",
    component: isMobile ? loginMobile : login,
    name: "loginwithcallback",
    props: true,
    meta: {
      layout: isMobile ? "mobile" : "default"
    }
  },
  {
    path: "/login",
    component: isMobile ? loginMobile : login,
    name: "login",
    props: true,
    meta: {
      layout: isMobile ? "mobile" : "default"
    }
  },
  {
    path: "/register",
    component: isMobile ? registerMobile : register,
    name: "registeruser",
    meta: {
      layout: isMobile ? "mobile" : "default"
    }
  },
  {
    path: "/store/:storename/resetpassword/:base64User",
    component: isMobile ? registerAccountMobile : registerAccount,
    name: "registerAccount",
    props: true,
    meta: {
      layout: isMobile ? "mobile" : "full"
    }
  },
  {
    path: "/profile",
    component: isMobile ? profileMobile : profile,
    name: "profile",
    meta: {
      layout: isMobile ? "mobile" : "default"
    }
  },
  {
    path: "/:storename/orderhistory",
    component: isMobile ? OrderHistoryMobile : OrderHistory,
    name: "orderhistory",
    meta: {
      layout: isMobile ? "mobile" : "default"
    }
  },
  {
    path: "/:storename/loyalty",
    component: isMobile ? LoyaltyMobile : Loyalty,
    name: "loyalty",
    meta: {
      layout: isMobile ? "mobile" : "default"
    }
  },
  {
    path: "/:storename/userStamps",
    component: isMobile ? userStampsMobile : userStamps,
    name: "userStamps",
    meta: {
      layout: isMobile ? "mobile" : "default"
    }
  },
  {
    path: "/:storename/ordertracking",
    component: isMobile ? OrderTrackingMobile : OrderTracking,
    name: "ordertracking",
    meta: {
      layout: isMobile ? "mobile" : "default"
    }
  },
  {
    path: "/contact",
    component: ContactPage,
    name: "contact"
  },
  {
    path: "/privacypolicy",
    component: PrivacyPage,
    name: "register"
  },
  {
    path: "/store/:storename",
    component: isMobile ? shopMobile : Shop,
    name: "store",
    props: true,
    meta: {
      layout: isMobile ? "mobile" : "full"
    }
  },
  {
    path: "/store/:storename/giftcards",
    component: isMobile ? giftshopMobile : giftshop,
    name: "giftstore",
    props: true,
    meta: {
      layout: isMobile ? "mobile" : "full"
    }
  },

  {
    name: "checkout",
    path: "/store/:storename/checkout/:orderid?",
    props: true,
    component: isMobile ? CheckoutMobile : Checkout,
    meta: {
      layout: isMobile ? "mobile" : "full"
    }
  },

  {
    name: "completeorder",
    path: "/store/:storename/completeorder/:orderid/:userid",
    props: true,
    component: isMobile ? CompleteOrderMobile : CompleteOrder,
    meta: {
      layout: isMobile ? "mobile" : "full"
    }
  },
  {
    name: "shoppingcartmobile",
    path: "/store/:storename/shoppingcartmobile/:qrcode?",
    component: ShoppingCartMobile,
    props: true,
    meta: {
      layout: "mobile"
    }
  },
  {
    name: "qrCodeScanner",
    path: "/store/:storename/qrcodescanner",
    component: QrCodeScanner,
    props: true,
    meta: {
      layout: "mobile"
    }
  },
  {
    name: "giftshoppingcartmobile",
    path: "/store/:storename/giftshoppingcartmobile",
    component: GiftShoppingCartMobile,
    props: true,
    meta: {
      layout: "mobile"
    }
  },
  {
    name: "generalError",
    path: "/generalError",
    component: GeneralError,
    meta: {
      layout: "default"
    }
  },
  {
    name: "LogViewer",
    path: "/LogViewer",
    component: LogViewer,
    meta: {
      layout: "default"
    }
  },
  {
    name: "notFoundPage",
    path: "/pagenotfound",
    component: PageNotFound,
    meta: {
      layout: "default"
    }
  },
  {
    name: "other",
    path: "*",
    component: isMobile ? IntroMobile : Intro,
    meta: {
      layout: isMobile ? "mobile" : "full"
    }
  },
  {
    name: "saveOrderMobile",
    path: "/store/:storename/saveOrderMobile",
    props: true,
    component: SaveOrderMobile,
    meta: {
      layout: "mobile"
    }
  }
];
/*eslint-disable*/
const router = new Router({
  routes: routes,
  mode: isWC ? "" : "history",
  scrollBehavior(to, from, savedPosition) {
    if (isWC) {
      return { selector: "#oo-embedded" };
    }
    return {
      x: 0,
      y: 0
    };
  }
});
router.beforeResolve((to, from, next) => {
  routerGuard(to, from, next);
});

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
});
export default router;
